import * as Yup from 'yup';

import { type FieldSchema, type ValidatorContext } from '../types';

const createRadioValidator = (context: ValidatorContext): FieldSchema => {
  const { l, isRequired, requiredMessage } = context;

  let validator = Yup.array()
    .of(Yup.string().required())
    .ensure()
    .max(1, l('Choose only one option'))
    .nullable();

  if (isRequired) {
    const message = requiredMessage ?? l('This field is required');

    validator = validator.min(1, message).required(message);
  }

  return validator;
};

export default createRadioValidator;
